import { Button, Dropdown } from 'react-bootstrap'
import { useState } from 'react'

import { Edit } from 'lucide-react'
import ButtonWithTooltip from '../../components/buttons/ButtonWithTooltip'
import useAuth from '../../hooks/useAuth'
import UpdateClubForm from '../admin/UpdateClubForm'
import UpdateClubAddressForm from './UpdateClubAddressForm'
import ClubOverview from './ClubOverview'
import ChangeClubTeamMember from './components/ChangeClubTeamMember'
import AddMemberSpaces from './components/UpdateMemberSpaces'
import getPosition from '../../utils/getPosition'

const POSITIONS = ['secretary', 'headCoach', 'welfareOfficer', 'dbsVerifier']

const ViewClubOverview = ({ clubId, club }) => {
  const { role } = useAuth()
  const { staff, membershipSpaces, isClubSecretary } = club

  const [showDropdown, setShowDropdown] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const updateDetailsClicked = () => {
    setEditMode((prev) => !prev)
    setShowDropdown(false)
  }

  let optionsButton

  if (role === "admin") {
    optionsButton = (
      <Dropdown show={showDropdown} onToggle={() => setShowDropdown((prev) => !prev)}>

        <Dropdown.Toggle
          variant=''
          id="dropdown-basic"
          className="no-arrow d-flex align-items-center justify-content-center rounded-circle p-2 bg-white shadow-btn border me-2"
        >
          <Edit />
        </Dropdown.Toggle>

        <Dropdown.Menu className="shadow px-2 border-0" style={{ width: "16rem" }}>
          <Button variant='' className='fw-semibold px-2 py-2 rounded border-0 custom-hover w-100 text-start' onClick={updateDetailsClicked}>
            {!editMode ? "Update" : "View"} Club Details
          </Button>

          {POSITIONS.map(position => (
            <ChangeClubTeamMember position={position} clubId={clubId} key={position} staff={staff}>
              <Button variant='' className='fw-semibold px-2 py-2 rounded border-0 custom-hover w-100 text-start'>
                Change {getPosition(position)}
              </Button>
            </ChangeClubTeamMember>
          ))}

          <AddMemberSpaces clubId={clubId} existingSpaces={membershipSpaces} >
            <Button variant='' className='fw-semibold px-2 py-2 rounded border-0 custom-hover w-100 text-start'>
              Update Member Spaces
            </Button>
          </AddMemberSpaces>
        </Dropdown.Menu>
      </Dropdown>
    )
  } else if (isClubSecretary) {
    optionsButton = (
      <Button onClick={() => setEditMode(state => !state)} className='d-flex align-items-center justify-content-center rounded-circle p-2 bg-white shadow-btn border' variant=''><Edit /></Button>
    )
  }

  return (
    <div
      className="w-100 mx-auto bg-white shadow-sm rounded-4 p-4"
    >
      <div className='d-flex justify-content-between align-items-center'>
        <h4 className="my-3 fw-bold ps-2">Club Details</h4>
        {optionsButton && (
          <ButtonWithTooltip text="Update" delay={750}>
            {optionsButton}
          </ButtonWithTooltip>
        )}
      </div>

      {/* Render content based on edit mode and user role */}
      {!editMode
        ? <ClubOverview club={club} />
        : role === "admin"
          ? <UpdateClubForm data={{ ...club, clubId }} setEditMode={setEditMode} />
          : <UpdateClubAddressForm data={{ ...club, clubId }} setEditMode={setEditMode} />
      }
    </div>
  )
}

export default ViewClubOverview